import {reject} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

const INFO_SEPARATOR = ' · ';

export const joinInfoLine = (parts: (string | null | undefined)[]): string =>
  reject(isNilOrEmpty, parts).join(INFO_SEPARATOR);
